import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, autorun, observable, computed } from 'mobx';
import HierTable from '../../HierTable';
import Spinner from '../../Spinner';
import * as api from '../../../actions/api';
import _ from 'lodash';

@inject('stationStore')
@observer
class StationDataSeries extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    stationStore: PropTypes.object.isRequired,
  };

  @observable items;
  @observable autoDataSeriesItems = [];
  actions;

  dispose;

  @computed get enableAutoGenerate() {
    const { stationStore, params: { id } } = this.props;
    const station = stationStore.findById(id);
    if (!(station && station.dataSeriesHier && station.dataSeriesHier.length) || !(station && station.dataOriginHier && station.dataOriginHier.length)) return true;
    let seriesParameters = _.uniq(station.dataSeriesHier.filter(item => item.level === 1).map(item => item.data.parameter_id)),
      originParameters = _.uniq(station.dataOriginHier.filter(item => item.level === 2).map(item => item.data.parameter_id));
    // console.log(_.intersection(seriesParameters, originParameters).length, seriesParameters.length, originParameters.length)
    // console.log(_.difference(seriesParameters, originParameters), _.difference(originParameters, seriesParameters))
    return _.intersection(seriesParameters, originParameters).length < originParameters.length;
  };

  constructor(props) {
    super(props);

    const { params: { id } } = props;
    this.actions = [
      // { label: 'QC', link: `/station/${id}/data-series/{id}/qc-rule`, level: 1 },
    ];

    this.handleDelete = this.handleDelete.bind(this);
    this.generateSeries = this.generateSeries.bind(this);
  }

  componentWillMount() {
    const { params: { id }, stationStore } = this.props;
    stationStore.fetchDataSeries(id);
    stationStore.fetchDataOrigins(id);
    // this.dispose = autorun(() => {
    //   const station = stationStore.findById(id);
    //   console.log(station.dataSeriesHier.filter(item => item.level === 1));
    //   console.log(station.dataOriginHier.filter(item => item.level === 2));
    // })
  }

  handleDelete(idOrIds) {
    const { notify } = this.context;
    const { params: { id: stationId }, stationStore } = this.props;
    stationStore.removeDataSeriesItem(stationId, idOrIds)
      .then(() => notify.success({ message: 'Success' }))
      .catch(notify.error);
  }

  generateSeries() {
    const { notify } = this.context;
    const { params: { id: stationId }, stationStore } = this.props;
    api.auto.postStationDataSeries(stationId)
      .then(action(autoDataSeriesItems => {
        return stationStore.fetchDataSeries(stationId);
      }))
      .then(() => notify.success({ message: 'Success' }))
      .catch(notify.error);
  }

  render() {
    const { params: { id }, children, stationStore } = this.props;
    const slug = `station/${id}/data-series`;
    const columns = [
      // { key: 'id', label: 'ID' },
      { key: 'name', label: 'Name' },
      { key: 'unit', label: 'Unit' },
      { key: 'qc', label: '' },
    ];
    const station = stationStore.findById(id);

    if (stationStore.isLoading && !children) { return <Spinner />; }
    // if(!!station) console.log(station.dataSeriesHier.filter(item => item.level === 1), station.dataOriginHier.filter(item => item.level === 2));

    return (
      <div>
        {this.enableAutoGenerate && <button className="button" onClick={this.generateSeries}>Auto Generate</button>}
        {this.autoDataSeriesItems.map(item => {
          return <div key={item.name}>{item.name}</div>;
        })}
        <HierTable
          data={station.dataSeriesHier}
          slug={slug}
          columns={columns}
          actions={this.actions}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resources={{ parent: 'data-series', child: 'qc-rule' }}
        />
        <div>
          {children}
        </div>
      </div>
    );
  }
}


export default StationDataSeries;



// WEBPACK FOOTER //
// ./src/components/Station/DataSeries/StationDataSeries.js